var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-resources-progress"},[_c('table-list',{attrs:{"title":"视频列表","loading":_vm.loading,"data":_vm.videoList,"columns":_vm.columns(this),"operates":_vm.operates(this),"pager":_vm.pager,"btns":_vm.btns(this)},on:{"search":_vm.onSearch,"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }